// extracted by css-extract-rspack-plugin
export default {"onboardPageContainer":"onboard-page__onboardPageContainer___kLUde common__flex___Q2pQy common__column___k70Tz"};